import styled from '@emotion/styled';
import React from 'react';
import InputSearch from '../../../../components/input/Input';
import InputDateForm from '../../../../components/input/InputDateForm';
import moment from 'moment';

const Search = ({ setFilters, filters, loadRelatorio }) => {
  const { search, dataFim, dataInicio } = filters;

  const handleChange = (value, field) => {
    if (field === 'dataInicio' || field === 'dataFim') {
      if (!value || value === 'Invalid date') return;

      setFilters({
        ...filters,
        [field]: value,
      });
    }

    setFilters({
      ...filters,
      [field]: value,
    });
  };

  return (
    <HeaderContainer>
      <InputSearch
        placeholder="Buscar por unidade"
        onChange={(e) => handleChange(e.target.value, 'search')}
        value={search}
      />
      <InputDateForm
        placeholder="Data inicio"
        variant="outlined"
        fullWidth
        value={dataInicio}
        onChange={(e) =>
          handleChange(moment(e).format('YYYY-MM-DD'), 'dataInicio')
        }
      />
      <InputDateForm
        placeholder="Data fim"
        variant="outlined"
        fullWidth
        value={dataFim}
        onChange={(e) =>
          handleChange(moment(e).format('YYYY-MM-DD'), 'dataFim')
        }
      />
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  background-color: #fff;
  border-radius: 16px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  padding: 16px;
  display: flex;
  gap: 16px;
`;

export default Search;
